var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.153 25.244 C 0.126 25.31 0.11 25.379 0.09 25.446 c -0.017 0.057 -0.039 0.112 -0.051 0.171 c -0.051 0.259 -0.051 0.525 0 0.783 c 0.012 0.059 0.034 0.114 0.051 0.171 c 0.02 0.068 0.036 0.136 0.063 0.202 c 0.028 0.067 0.066 0.128 0.101 0.192 c 0.028 0.051 0.05 0.104 0.083 0.153 c 0.074 0.11 0.157 0.213 0.251 0.306 l 18.228 18.228 c 0.39 0.391 0.902 0.585 1.414 0.585 s 1.024 -0.194 1.414 -0.585 c 0.781 -0.781 0.781 -2.047 0 -2.828 L 6.829 28.009 H 88 c 1.104 0 2 -0.896 2 -2 s -0.896 -2 -2 -2 H 6.829 L 21.644 9.194 c 0.781 -0.781 0.781 -2.047 0 -2.828 c -0.78 -0.781 -2.048 -0.781 -2.828 0 L 0.587 24.594 C 0.494 24.687 0.41 24.79 0.337 24.9 c -0.033 0.049 -0.055 0.102 -0.083 0.153 C 0.219 25.116 0.181 25.177 0.153 25.244 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "var(--mainColor)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89.846 64.759 c 0.016 -0.038 0.023 -0.079 0.037 -0.118 c 0.029 -0.084 0.06 -0.166 0.077 -0.255 C 89.986 64.256 90 64.124 90 63.99 s -0.014 -0.266 -0.04 -0.395 c -0.018 -0.088 -0.049 -0.171 -0.077 -0.255 c -0.014 -0.039 -0.021 -0.08 -0.037 -0.118 c -0.038 -0.091 -0.088 -0.176 -0.138 -0.259 c -0.016 -0.027 -0.028 -0.058 -0.046 -0.084 c -0.073 -0.109 -0.156 -0.211 -0.249 -0.303 L 71.185 44.347 c -0.781 -0.781 -2.047 -0.781 -2.828 0 c -0.781 0.781 -0.781 2.047 0 2.829 L 83.172 61.99 H 2 c -1.104 0 -2 0.896 -2 2 s 0.896 2 2 2 h 81.172 L 68.356 80.806 c -0.781 0.781 -0.781 2.047 0 2.828 c 0.391 0.391 0.902 0.586 1.414 0.586 s 1.023 -0.195 1.414 -0.586 l 18.228 -18.228 c 0.093 -0.092 0.176 -0.194 0.249 -0.303 c 0.018 -0.027 0.029 -0.057 0.046 -0.084 C 89.758 64.934 89.808 64.85 89.846 64.759 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "var(--mainColor)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.72bc0e731b6954326578982a2951c352.svg";
export { ForwardRef as ReactComponent };